import { render } from "./OfferList.vue?vue&type=template&id=0941099a&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"

import "./OfferList.vue?vue&type=style&index=0&id=0941099a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0941099a"]])

export default __exports__